import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import sunFill from '@iconify/icons-eva/sun-fill';
import moonFill from '@iconify/icons-eva/moon-fill';
import { alpha, useTheme } from '@mui/material/styles';
import { IconButton, Tooltip } from '@mui/material';
import { useThemeMode } from '../theme/ThemeModeProvider';

export default function ThemeModeToggle({ sx, ...other }) {
  const theme = useTheme();
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'} placement="bottom">
      <IconButton
        onClick={toggleMode}
        sx={{
          color: isDark ? theme.palette.warning.light : theme.palette.info.main,
          backgroundColor: alpha(theme.palette.background.paper, 0.9),
          border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(1),
          boxShadow: theme.customShadows?.z8 || 'none',
          transition: theme.transitions.create(
            ['transform', 'background-color', 'box-shadow'],
            { duration: theme.transitions.duration.shorter }
          ),
          '&:hover': {
            transform: 'translateY(-2px)',
            backgroundColor: alpha(theme.palette.background.paper, 1),
            boxShadow: theme.customShadows?.z12 || theme.customShadows?.z8 || 'none'
          },
          ...sx
        }}
        {...other}
      >
        <Icon icon={isDark ? sunFill : moonFill} width={22} height={22} />
      </IconButton>
    </Tooltip>
  );
}

ThemeModeToggle.propTypes = {
  sx: PropTypes.object
};
